export default "__VITE_ASSET__CGEVJcH7__"